import React           from 'react';
import useGET          from 'rest/useGET';
import { useNavigate } from 'react-router-dom';
import usePOST         from 'rest/usePOST';
import useStyles       from './reportsPageStyles';

import NavBar             from 'NavBar';
import Paper              from '@mui/material/Paper';
import ReportsForm        from 'pages/ReportsPage/ReportsForm';
import ResultNotification from 'components/ResultNotification';
import WaitForReports     from 'pages/ReportsPage/WaitForReports';

import createRestRequestConfig from 'rest/createRestRequestConfig';

import { AuthContext }       from 'App';
import { BACKEND_PATHS }     from 'rest/const';
import { FINTECH_PATHS }     from 'rest/const';
import { HIDDEN_TABS }       from 'rest/const';
import internalPaths         from 'routing/internalPaths';


function ReportsPage() {

  const navigate     = useNavigate();
  const { classes }  = useStyles();
  const { userInfo } = React.useContext(AuthContext);

  React.useEffect(() => { //REACT complained that I should do it in useEffect and not on first render
    if (HIDDEN_TABS.reports) { //Someone might know URL and try to access it directly
      navigate(internalPaths.login);
    }
  }, [navigate]);

  const [submitData, setSubmitData]               = React.useState(undefined);
  const [submitResultAlert, setSubmitResultAlert] = React.useState(undefined);

  const swrOptionsGET = {
    revalidateIfStale:     false,
    revalidateOnFocus:     false,
    revalidateOnReconnect: false
  }

  const { data: response, error } = useGET(BACKEND_PATHS.reports, null, swrOptionsGET);
  const availableReports          = response?.data;

  function handleSubmit(reportList) {
    const toBeSubmitted = { reportList };
    setSubmitData(toBeSubmitted);
    mutate();
  }

  function onSubmitSuccess(response) {
    const status    = response?.status;
    const isSuccess = status >= 200 && status < 300;
    if (!isSuccess) {
      onSubmitError(response);
      return;
    }

    setSubmitResultAlert({
      msgTranslKey:          'success',
      msgTranslSecondaryKey: 'orderAccepted',
      type:                  'success'
    });
    setSubmitData(null);
  }

  function onSubmitError(errOrResp) {
    console.error("Ordering cards failed", errOrResp)
    setSubmitResultAlert({
      msgTranslKey:          'serverError',
      msgTranslSecondaryKey: 'orderNotSent',
      type:                  'error'
    });
    setSubmitData(null);  //to prevent resending them on rerender
  }

  const swrOptionsPOST = {
    shouldRetryOnError: false,
    onSuccess:          onSubmitSuccess,
    onError:            onSubmitError
  }
  const axiosCfg       = createRestRequestConfig(userInfo.accessToken, true);
  const path           = submitData ? FINTECH_PATHS.orderReports : null;

  const { isValidating, mutate } = usePOST(path, submitData, axiosCfg, swrOptionsPOST);

  function reset() {
    setSubmitData(null);
    setSubmitResultAlert(null);
  }

  const waitingForData    = !availableReports || isValidating;
  const isResultReady     = !!submitResultAlert;
  const hideForm          = isResultReady || waitingForData;
  const hideWaitComponent = isResultReady || !waitingForData;

  return (
    <>
      <NavBar/>
      <Paper elevation={3} className={classes.paper}>
        <div hidden={hideWaitComponent}>
          <WaitForReports error={error} isValidating={isValidating}/>
        </div>
        <div hidden={hideForm}>
          <ReportsForm
            availableReports={availableReports}
            onSubmit={handleSubmit}
          />
        </div>
        <ResultNotification
          reset={reset}
          alert={submitResultAlert}
        />
      </Paper>
    </>
  )
}

export default ReportsPage;